import { FIREBASE_ERRORS } from './errors';
import { FirebaseError } from 'firebase/app';

export const throwLoginErrors = (error: FirebaseError) => {
  if (error?.code === FIREBASE_ERRORS.AUTH_USER_DISABLED) {
    return { message: 'Your account has been disabled.' };
  }

  // Handle authentication failure errors with actionable guidance
  if (
    error?.code === FIREBASE_ERRORS.AUTH_INVALID_CREDENTIAL ||
    error?.code === FIREBASE_ERRORS.AUTH_USER_NOT_FOUND ||
    error?.code === FIREBASE_ERRORS.AUTH_WRONG_PASSWORD
  ) {
    return { message: "Unable to validate user. Please try again or click 'Forgot password?' below." };
  }

  return { message: 'An error occurred. Please try again.' };
};
